package com.solevo.dist.i18n

data class Strings(
    val settingsTitle: String,
    val settingsTabPersonal: String,
    val settingsTabCompany: String,
    val settingsLogout: String,
    val languageTitle: String,
    val apply: String,
    val close: String,
    // Settings item labels
    val labelName: String,
    val labelCustomerId: String,
    val labelCountry: String,
    val labelLanguage: String,
    val labelPhoneNumber: String,
    val labelId: String,
    val labelAddress: String,
    val labelTier: String,
    val labelCompany: String,
    val labelTermsAndPrivacy: String,
    // Orders
    val ordersTitle: String,
    val ordersTabAll: String,
    val ordersTabCreated: String,
    val ordersTabConfirmed: String,
    val ordersTabExpired: String,
    val ordersTabClosed: String,
    val ordersTabCancelled: String,
    val ordersTabError: String,
    val ordersHeaderAmount: String,
    val ordersHeaderDescription: String,
    val ordersHeaderPickupDate: String,
    val ordersHeaderDateCreated: String,
    val ordersEmpty: String,
    val errorPrefix: String,
    val wordOrder: String,
    val orderStatusInitialized: String,
    val orderStatusCreated: String,
    val orderStatusConfirmed: String,
    val orderStatusExpired: String,
    val orderStatusCancelled: String,
    val orderStatusClosed: String,
    val orderStatusError: String
    ,
    // Common / App
    val appTitle: String,
    val loading: String,
    val login: String,
    val sendCode: String,
    val resendCode: String,
    val resendCodeIn: String,
    val otpResent: String,
    val cont: String,
    val noData: String,
    // Login page
    val loginPhone: String,
    val loginEmail: String,
    val loginEnterPhone: String,
    val loginPhonePlaceholder: String,
    val loginEnterEmail: String,
    val loginEmailPlaceholder: String,
    val loginEmailAccepted: String,
    val loginStepBack: String,
    val loginEnterCode: String,
    val loginCodeDescription: String,
    // Quotes
    val quotesTitle: String,
    val quotesEmpty: String,
    val quotesEmptyMessage: String,
    val quotesTabAll: String,
    val quotesTabAwaiting: String,
    val quotesTabReceived: String,
    val quotesStatusAwaiting: String,
    val quotesStatusReceived: String,
    val quotesStatusError: String,
    val quotesHeaderAmount: String,
    val quotesHeaderDescription: String,
    val quotesHeaderPickupDate: String,
    val quotesHeaderDateCreated: String,
    // Statement
    val statementTitle: String,
    val includeOpenOrders: String,
    val startDate: String,
    val endDate: String,
    val applyFilters: String,
    val statementsEmpty: String,
    val statementsEmptyMessage: String,
    val statementHeaderInvoice: String,
    val statementHeaderStatus: String,
    val statementHeaderDueDate: String,
    val statementHeaderTotal: String,
    // Order / Invoice / Delivery labels
    val download: String,
    val details: String,
    val repayment: String,
    val allItems: String,
    val noDeliveryNotesTitle: String,
    val noDeliveryNotesMsg: String,
    val noInvoicesTitle: String,
    val noInvoicesMsg: String
    ,
    // Nav
    val navOrders: String,
    val navQuotes: String,
    val navStatement: String,
    val navRewards: String,
    val navSettings: String,
    // Quote / Details common labels
    val labelReference: String,
    val labelCustomerReference: String,
    val labelOrderId: String,
    val labelQuoteId: String,
    val labelStatus: String,
    val labelDateCreated: String,
    val labelPickupDate: String,
    val headerProduct: String,
    val headerTotal: String,
    val headerWarehouse: String,
    val headerUnits: String,
    val headerPricePerUnit: String,
    val headerNote: String,
    val headerDate: String,
    val headerInvoice: String,
    val headerDueDate: String
    ,
    val labelRemainingAmount: String,
    val labelDeliveryNote: String,
    val labelQuote: String,
    val headerQuantity: String,
    val labelRemaining: String,
    val labelDeliveryNotes: String,
    val labelInvoices: String,
    val noRemainingItemsTitle: String,
    // Transaction type prefixes
    val wordInvoice: String,
    val wordCreditNote: String,
    val wordPayment: String,
    val noRemainingItemsMsg: String,
    val noItemsTitle: String,
    val noItemsMsg: String
    ,
    // Statement left summary + tabs
    val statementAvailableCredit: String,
    val statementTotalCreditLine: String,
    val statementOpenInvoices: String,
    val statementGoodsInDelivery: String,
    val statementTabAll: String,
    val statementTabOpen: String,
    // Rewards
    val rewardsTitle: String,
    val rewardsRebates: String,
    val rewardsAccruedRebate: String,
    val rewardsCreditScore: String,
    val rewardsCreditScoreLabel: String,
    val rewardsPaymentTerms: String,
    val rewardsCreditLine: String
    ,
    // Invoice details
    val labelInvoiceId: String,
    val labelPaid: String
    ,
    // Product details
    val productDetailsTitle: String,
    val productInformationTitle: String,
    val packaging: String,
    val productFamily: String,
    val registrationNo: String,
    val productDetailsLabel: String,
    val generalScope: String,
    val ingredientsTitle: String,
    val activeIngredients: String,
    val formulation: String,
    val chemicalFamily: String,
    val preparationTitle: String,
    val directionsForUse: String,
    val afterglow: String,
        val preHarvestInterval: String,
        val timeToHarvest: String,
        val reEntryPeriod: String,
    val safetyTitle: String,
    val toxicity: String,
    val safetyPhrases: String,
    val firstCareDoctorInfo: String,
    val applicationTitle: String,
    val cultures: String,
    val targetRegistration: String,
    val applicationRates: String,
    val applicationPeriod: String,
    val moreDetailedModeOfAction: String,
    val productStrengths: String,
    // Invoice status
    val invoiceStatusDue: String,
    val invoiceStatusOverdue: String,
    val invoiceStatusClosed: String
)

object StringsEn {
    val value = Strings(
        settingsTitle = "Settings",
        settingsTabPersonal = "Personal",
        settingsTabCompany = "Company",
        settingsLogout = "Logout",
        languageTitle = "Language",
        apply = "Apply",
        close = "Close",
        labelName = "Name",
        labelCustomerId = "Customer ID",
        labelCountry = "Country",
        labelLanguage = "Language",
        labelPhoneNumber = "Phone number",
        labelId = "ID",
        labelAddress = "Address",
        labelTier = "Tier",
        labelCompany = "Company",
        labelTermsAndPrivacy = "Terms & Privacy",
        ordersTitle = "Orders",
        ordersTabAll = "All",
        ordersTabCreated = "Created",
        ordersTabConfirmed = "Confirmed",
        ordersTabExpired = "Expired",
        ordersTabClosed = "Closed",
        ordersTabCancelled = "Cancelled",
        ordersTabError = "Error",
        ordersHeaderAmount = "Amount",
        ordersHeaderDescription = "Description",
        ordersHeaderPickupDate = "Pickup date",
        ordersHeaderDateCreated = "Date created",
        ordersEmpty = "No orders",
        errorPrefix = "Error",
        wordOrder = "Order",
        orderStatusInitialized = "Initialized",
        orderStatusCreated = "Created",
        orderStatusConfirmed = "Confirmed",
        orderStatusExpired = "Expired",
        orderStatusCancelled = "Cancelled",
        orderStatusClosed = "Closed",
        orderStatusError = "Error",
        appTitle = "My Solevo",
        loading = "Loading...",
        login = "Login",
        sendCode = "Send Code",
        resendCode = "Resend Code",
        resendCodeIn = "Resend code in {seconds}s",
        otpResent = "A new code has been sent",
        cont = "Continue",
        noData = "No data",
        loginPhone = "Phone",
        loginEmail = "Email",
        loginEnterPhone = "Enter your phone number",
        loginPhonePlaceholder = "87 78 123",
        loginEnterEmail = "Enter your email address",
        loginEmailPlaceholder = "mark.carney@google.com",
        loginEmailAccepted = "Email accepted",
        loginStepBack = "‹ Step 1/3",
        loginEnterCode = "Enter code",
        loginCodeDescription = "Enter the code sent to your phone or email",
        quotesTitle = "Quotes",
        quotesEmpty = "No Result Found",
        quotesEmptyMessage = "Your filter selection did not match any items in the list.",
        quotesTabAll = "All",
        quotesTabAwaiting = "Awaiting Quote",
        quotesTabReceived = "Quote received",
        quotesStatusAwaiting = "Awaiting quote",
        quotesStatusReceived = "Quote received",
        quotesStatusError = "Error",
        quotesHeaderAmount = "AMOUNT",
        quotesHeaderDescription = "DESCRIPTION",
        quotesHeaderPickupDate = "PICKUP DATE",
        quotesHeaderDateCreated = "DATE CREATED",
        statementTitle = "Statement",
        includeOpenOrders = "Include open orders",
        startDate = "Start date",
        endDate = "End date",
        applyFilters = "Apply filters",
        statementsEmpty = "No Result Found",
        statementsEmptyMessage = "Your filter selection did not match any items in the list.",
        statementHeaderInvoice = "INVOICE",
        statementHeaderStatus = "STATUS",
        statementHeaderDueDate = "Due Date",
        statementHeaderTotal = "Total",
        download = "Download",
        details = "Details",
        repayment = "Repayment",
        allItems = "All items",
        noDeliveryNotesTitle = "No Delivery Notes",
        noDeliveryNotesMsg = "You have no delivery notes in this order.",
        noInvoicesTitle = "No Invoices",
        noInvoicesMsg = "You have no invoices in this order",
        navOrders = "Orders",
        navQuotes = "Quotes",
        navStatement = "Statement",
        navRewards = "Rewards",
        navSettings = "Settings",
        labelReference = "Reference",
        labelCustomerReference = "Customer Reference",
        labelOrderId = "Order ID",
        labelQuoteId = "Quote ID",
        labelStatus = "Status",
        labelDateCreated = "Date created",
        labelPickupDate = "Pickup date",
        headerProduct = "PRODUCT",
        headerTotal = "Total",
        headerWarehouse = "WAREHOUSE",
        headerUnits = "UNITS",
        headerPricePerUnit = "PRICE PER UNIT",
        headerNote = "NOTE",
        headerDate = "DATE",
        headerInvoice = "INVOICE",
        headerDueDate = "Due Date",
        labelRemainingAmount = "Remaining amount",
        labelDeliveryNote = "Delivery note",
        labelQuote = "Quote",
        headerQuantity = "QUANTITY",
        labelRemaining = "Remaining",
        labelDeliveryNotes = "Delivery notes",
        labelInvoices = "Invoices",
        noRemainingItemsTitle = "No Remaining Items",
        noRemainingItemsMsg = "You have no remaining items in this order.",
        noItemsTitle = "No Items",
        noItemsMsg = "This order has no items to display.",
        statementAvailableCredit = "Available credit",
        statementTotalCreditLine = "Total credit line",
        statementOpenInvoices = "Open invoices",
        statementGoodsInDelivery = "Goods in delivery",
        statementTabAll = "All",
        statementTabOpen = "Open",
        rewardsTitle = "Rewards",
        rewardsRebates = "Rebates",
        rewardsAccruedRebate = "Accrued rebate",
        rewardsCreditScore = "Credit Score",
        rewardsCreditScoreLabel = "Credit score",
        rewardsPaymentTerms = "Payment terms",
        rewardsCreditLine = "Credit line"
        ,
        wordInvoice = "Invoice",
        wordCreditNote = "Credit Note",
        wordPayment = "Payment",
        labelInvoiceId = "Invoice ID",
        labelPaid = "Paid"
        ,
        productDetailsTitle = "Product",
        productInformationTitle = "Product Information",
        packaging = "Packaging",
        productFamily = "Product family",
        registrationNo = "Registration no.",
        productDetailsLabel = "Product details",
        generalScope = "General scope of the product (targets)",
        ingredientsTitle = "Ingredients",
        activeIngredients = "Active ingredient(s)",
        formulation = "Formulation",
        chemicalFamily = "Chemical family(ies)",
        preparationTitle = "Preparation",
        directionsForUse = "Directions for use",
        afterglow = "Afterglow",
        preHarvestInterval = "Pre-harvest interval",
        timeToHarvest = "Time to harvest",
        reEntryPeriod = "Re-entry period",
        safetyTitle = "Safety",
        toxicity = "Toxicity (who)",
        safetyPhrases = "Safety phrases",
        firstCareDoctorInfo = "1st Care and doctor info",
        applicationTitle = "Application",
        cultures = "Culture(s)",
        targetRegistration = "Target(s) registration",
        applicationRates = "Application rate(s)",
        applicationPeriod = "Application period",
        moreDetailedModeOfAction = "More detailed mode of action",
        productStrengths = "Product strengths",
        invoiceStatusDue = "Due",
        invoiceStatusOverdue = "Overdue",
        invoiceStatusClosed = "Closed"
    )
}

object StringsFr {
    val value = Strings(
        settingsTitle = "Paramètres",
        settingsTabPersonal = "Utilisateur",
        settingsTabCompany = "Entreprise",
        settingsLogout = "Se déconnecter",
        languageTitle = "Langue",
        apply = "Appliquer",
        close = "Fermer",
        labelName = "Nom",
        labelCustomerId = "ID CLIENT",
        labelCountry = "Pays",
        labelLanguage = "Langue",
        labelPhoneNumber = "Numéro de téléphone",
        labelId = "ID CLIENT",
        labelAddress = "Adresse",
        labelTier = "Tier",
        labelCompany = "Entreprise",
        labelTermsAndPrivacy = "Conditions & Confidentialité",
        ordersTitle = "Commandes",
        ordersTabAll = "Toutes",
        ordersTabCreated = "Créée",
        ordersTabConfirmed = "Confirmée",
        ordersTabExpired = "Expiré",
        ordersTabClosed = "Clôturées",
        ordersTabCancelled = "Annulée",
        ordersTabError = "Erreur",
        ordersHeaderAmount = "Montant",
        ordersHeaderDescription = "Description",
        ordersHeaderPickupDate = "Date de ramassage",
        ordersHeaderDateCreated = "Date créée",
        ordersEmpty = "Aucune commande",
        errorPrefix = "Erreur",
        wordOrder = "Commande",
        orderStatusInitialized = "Initialisée",
        orderStatusCreated = "Créée",
        orderStatusConfirmed = "Confirmée",
        orderStatusExpired = "Expirée",
        orderStatusCancelled = "Annulée",
        orderStatusClosed = "Clôturée",
        orderStatusError = "Erreur",
        appTitle = "My Solevo",
        loading = "Chargement...",
        login = "Connexion",
        sendCode = "Envoyer le code",
        resendCode = "Renvoyer le code",
        resendCodeIn = "Renvoyer le code dans {seconds}s",
        otpResent = "Un nouveau code a été envoyé",
        cont = "Continuer",
        noData = "Aucune donnée",
        loginPhone = "Téléphone",
        loginEmail = "E-mail",
        loginEnterPhone = "Entrez votre numéro de téléphone",
        loginPhonePlaceholder = "87 78 123",
        loginEnterEmail = "Entrez votre adresse e-mail",
        loginEmailPlaceholder = "mark.carney@google.com",
        loginEmailAccepted = "E-mail accepté",
        loginStepBack = "‹ Étape 1/3",
        loginEnterCode = "Entrez le code",
        loginCodeDescription = "Entrez le code envoyé à votre téléphone ou e-mail",
        quotesTitle = "Devis",
        quotesEmpty = "Aucun résultat trouvé",
        quotesEmptyMessage = "Votre sélection de filtre ne correspond à aucun élément de la liste.",
        quotesTabAll = "Tous",
        quotesTabAwaiting = "Devis en attente",
        quotesTabReceived = "Devis reçu",
        quotesStatusAwaiting = "Devis en attente",
        quotesStatusReceived = "Devis reçu",
        quotesStatusError = "Erreur",
        quotesHeaderAmount = "MONTANT",
        quotesHeaderDescription = "DESCRIPTION",
        quotesHeaderPickupDate = "DATE DE RAMASSAGE",
        quotesHeaderDateCreated = "DATE CRÉÉE",
        statementTitle = "Relevé",
        includeOpenOrders = "Inclure les commandes en cours",
        startDate = "Date de début",
        endDate = "Date de fin",
        applyFilters = "Appliquer les filtres",
        statementsEmpty = "Aucun résultat trouvé",
        statementsEmptyMessage = "Votre sélection de filtre ne correspond à aucun élément de la liste.",
        statementHeaderInvoice = "FACTURE",
        statementHeaderStatus = "STATUT",
        statementHeaderDueDate = "DATE D'ÉCHÉANCE",
        statementHeaderTotal = "Total",
        download = "Télécharger",
        details = "Détails",
        repayment = "Remboursement",
        allItems = "Articles",
        noDeliveryNotesTitle = "Pas de bons de livraison",
        noDeliveryNotesMsg = "Vous n’avez pas de bons de livraison pour cette commande.",
        noInvoicesTitle = "Pas de factures",
        noInvoicesMsg = "Vous n'avez pas de factures pour cette commande",
        navOrders = "Commandes",
        navQuotes = "Devis",
        navStatement = "Relevé",
        navRewards = "Récompenses",
        navSettings = "Paramètres",
        labelReference = "Référence",
        labelCustomerReference = "Référence client",
        labelOrderId = "Commande ID",
        labelQuoteId = "Devis ID",
        labelStatus = "Statut",
        labelDateCreated = "Date créée",
        labelPickupDate = "Date de ramassage",
        headerProduct = "PRODUIT",
        headerTotal = "Total",
        headerWarehouse = "ENTREPÔT",
        headerUnits = "UNITÉS",
        headerPricePerUnit = "PRIX / UNITÉ",
        headerNote = "BON",
        headerDate = "DATE",
        headerInvoice = "FACTURE",
        headerDueDate = "DATE D’ÉCHÉANCE",
        labelRemainingAmount = "Montant restant",
        labelDeliveryNote = "Bon de livraison",
        labelQuote = "Devis",
        headerQuantity = "QUANTITÉ",
        labelRemaining = "Restant",
        labelDeliveryNotes = "Bons de livraison",
        labelInvoices = "Factures",
        noRemainingItemsTitle = "Aucun article restant",
        noRemainingItemsMsg = "Vous n’avez pas d’articles restants pour cette commande.",
        noItemsTitle = "Aucun article",
        noItemsMsg = "Cette commande n’a aucun article à afficher.",
        statementAvailableCredit = "Crédit disponible",
        statementTotalCreditLine = "Limite de crédit",
        statementOpenInvoices = "Factures non payées",
        statementGoodsInDelivery = "Produits en livraison",
        statementTabAll = "Toutes",
        statementTabOpen = "Ouvertes",
        rewardsTitle = "Récompenses",
        rewardsRebates = "Rabais",
        rewardsAccruedRebate = "Rabais cumulés",
        rewardsCreditScore = "Score de crédit",
        rewardsCreditScoreLabel = "Score de crédit",
        rewardsPaymentTerms = "Conditions de paiement",
        rewardsCreditLine = "Ligne de crédit"
        ,
        wordInvoice = "Facture",
        wordCreditNote = "Note de crédit",
        wordPayment = "Paiement",
        labelInvoiceId = "ID facture",
        labelPaid = "Payé"
        ,
        productDetailsTitle = "Produit",
        productInformationTitle = "Informations sur le produit",
        packaging = "Conditionnement",
        productFamily = "Famille de produit",
        registrationNo = "N° homologation",
        productDetailsLabel = "Detail du produit",
        generalScope = "Scope general du produit (cible(s))",
        ingredientsTitle = "Ingrédients",
        activeIngredients = "Matiere(s) active(s)",
        formulation = "Formulation",
        chemicalFamily = "Famille(s) chimique(s)",
        preparationTitle = "Préparation",
        directionsForUse = "Mode d’emploi",
        afterglow = "Rémanence",
        preHarvestInterval = "Délai avant récolte",
        timeToHarvest = "Delai avant recolte (D.A.R.)",
        reEntryPeriod = "Délai de rentrée",
        safetyTitle = "Sécurité",
        toxicity = "Toxicite (who)",
        safetyPhrases = "Phrases de sécurité",
        firstCareDoctorInfo = "1re aide et info médecin",
        applicationTitle = "Application",
        cultures = "Culture(s)",
        targetRegistration = "Cible(s) d’homologation",
        applicationRates = "Dose(s) d’application",
        applicationPeriod = "Période d’application",
        moreDetailedModeOfAction = "Mode d'action plus detaille",
        productStrengths = "Points forts du produit",
        invoiceStatusDue = "Non payé",
        invoiceStatusOverdue = "En retard",
        invoiceStatusClosed = "Payée"
    )
}

object StringsPt {
    val value = Strings(
        settingsTitle = "Configurações",
        settingsTabPersonal = "Pessoal",
        settingsTabCompany = "Empresa",
        settingsLogout = "Sair",
        languageTitle = "Idioma",
        apply = "Aplicar",
        close = "Fechar",
        labelName = "Nome",
        labelCustomerId = "ID do cliente",
        labelCountry = "País",
        labelLanguage = "Idioma",
        labelPhoneNumber = "Número de telefone",
        labelId = "ID",
        labelAddress = "Endereço",
        labelTier = "Nível",
        labelCompany = "Empresa",
        labelTermsAndPrivacy = "Termos & Privacidade",
        ordersTitle = "Encomendas",
        ordersTabAll = "Todos",
        ordersTabCreated = "Criada",
        ordersTabConfirmed = "Confirmada",
        ordersTabExpired = "Expirado",
        ordersTabClosed = "Anulada",
        ordersTabCancelled = "Fechada",
        ordersTabError = "Erro",
        ordersHeaderAmount = "Valor",
        ordersHeaderDescription = "Descrição",
        ordersHeaderPickupDate = "Data de retirada",
        ordersHeaderDateCreated = "Data de criação",
        ordersEmpty = "Nenhuma encomenda",
        errorPrefix = "Erro",
        wordOrder = "Encomenda",
        orderStatusInitialized = "Inicializado",
        orderStatusCreated = "Criada",
        orderStatusConfirmed = "Confirmada",
        orderStatusExpired = "Expirado",
        orderStatusCancelled = "Fechada",
        orderStatusClosed = "Anulada",
        orderStatusError = "Erro",
        appTitle = "My Solevo",
        loading = "Carregando...",
        login = "Entrar",
        sendCode = "Enviar código",
        resendCode = "Reenviar código",
        resendCodeIn = "Reenviar código em {seconds}s",
        otpResent = "Um novo código foi enviado",
        cont = "Continuar",
        noData = "Sem dados",
        loginPhone = "Telefone",
        loginEmail = "E-mail",
        loginEnterPhone = "Digite seu número de telefone",
        loginPhonePlaceholder = "87 78 123",
        loginEnterEmail = "Digite seu endereço de e-mail",
        loginEmailPlaceholder = "mark.carney@google.com",
        loginEmailAccepted = "E-mail aceito",
        loginStepBack = "‹ Etapa 1/3",
        loginEnterCode = "Digite o código",
        loginCodeDescription = "Digite o código enviado para seu telefone ou e-mail",
        quotesTitle = "Cotações",
        quotesEmpty = "Nenhum resultado encontrado",
        quotesEmptyMessage = "Sua seleção de filtro não correspondeu a nenhum item da lista.",
        quotesTabAll = "Todos",
        quotesTabAwaiting = "Cotação pendente",
        quotesTabReceived = "Cotação recebida",
        quotesStatusAwaiting = "Cotação pendente",
        quotesStatusReceived = "Cotação recebida",
        quotesStatusError = "Erro",
        quotesHeaderAmount = "VALOR",
        quotesHeaderDescription = "DESCRIÇÃO",
        quotesHeaderPickupDate = "DATA DE RETIRADA",
        quotesHeaderDateCreated = "DATA DE CRIAÇÃO",
        statementTitle = "Extrato",
        includeOpenOrders = "Incluir as encomendas actuais",
        startDate = "Data inicial",
        endDate = "Data final",
        applyFilters = "Aplicar filtros",
        statementsEmpty = "Nenhum resultado encontrado",
        statementsEmptyMessage = "Sua seleção de filtro não correspondeu a nenhum item da lista.",
        statementHeaderInvoice = "FATURA",
        statementHeaderStatus = "STATUS",
        statementHeaderDueDate = "DATA DE VENC.",
        statementHeaderTotal = "Total",
        download = "Baixar",
        details = "Detalhes",
        repayment = "Reembolso",
        allItems = "Todos os itens",
        noDeliveryNotesTitle = "Sem Notas de Entrega",
        noDeliveryNotesMsg = "Você não possui notas de entrega neste pedido.",
        noInvoicesTitle = "Sem Faturas",
        noInvoicesMsg = "Você não possui faturas neste pedido",
        navOrders = "Encomendas",
        navQuotes = "Cotações",
        navStatement = "Extrato",
        navRewards = "Recompensas",
        navSettings = "Configurações",
        labelReference = "Referência",
        labelCustomerReference = "Referência do cliente",
        labelOrderId = "Encomenda ID",
        labelQuoteId = "Cotação ID",
        labelStatus = "Estado",
        labelDateCreated = "Data criada",
        labelPickupDate = "Data de retirada",
        headerProduct = "PRODUTO",
        headerTotal = "Total",
        headerWarehouse = "ARMAZÉM",
        headerUnits = "UNIDADES",
        headerPricePerUnit = "PREÇO / UNIDADE",
        headerNote = "NOTA",
        headerDate = "DATA",
        headerInvoice = "FATURA",
        headerDueDate = "DATA DE VENC.",
        labelRemainingAmount = "Valor remanescente",
        labelDeliveryNote = "Nota de entrega",
        labelQuote = "Cotação",
        headerQuantity = "QUANTIDADE",
        labelRemaining = "Restante",
        labelDeliveryNotes = "Notas de entrega",
        labelInvoices = "Faturas",
        noRemainingItemsTitle = "Sem itens restantes",
        noRemainingItemsMsg = "Você não possui itens restantes neste pedido.",
        noItemsTitle = "Sem itens",
        noItemsMsg = "Este pedido não possui itens para exibir.",
        statementAvailableCredit = "Plafond disponivel",
        statementTotalCreditLine = "Limite de crédito",
        statementOpenInvoices = "Faturas não pagas",
        statementGoodsInDelivery = "Mercadorias em entrega",
        statementTabAll = "Todo",
        statementTabOpen = "Aberto",
        rewardsTitle = "Recompensas",
        rewardsRebates = "Rebates",
        rewardsAccruedRebate = "Rebate acumulado",
        rewardsCreditScore = "Score de crédito",
        rewardsCreditScoreLabel = "Score de crédito",
        rewardsPaymentTerms = "Condições de pagamento",
        rewardsCreditLine = "Linha de crédito"
        ,
        wordInvoice = "Fatura",
        wordCreditNote = "Nota de crédito",
        wordPayment = "Pagamento",
        labelInvoiceId = "ID da fatura",
        labelPaid = "Pago"
        ,
        productDetailsTitle = "Produto",
        productInformationTitle = "Informações do produto",
        packaging = "Embalagem",
        productFamily = "Família do produto",
        registrationNo = "Nº de registro",
        productDetailsLabel = "Detalhes do produto",
        generalScope = "Escopo geral do produto (alvos)",
        ingredientsTitle = "Ingredientes",
        activeIngredients = "Ingrediente(s) ativo(s)",
        formulation = "Formulação",
        chemicalFamily = "Família(s) química(s)",
        preparationTitle = "Preparação",
        directionsForUse = "Modo de uso",
        afterglow = "Persistência",
        preHarvestInterval = "Intervalo pré-colheita",
        timeToHarvest = "Tempo até a colheita",
        reEntryPeriod = "Período de reentrada",
        safetyTitle = "Segurança",
        toxicity = "Toxicidade (OMS)",
        safetyPhrases = "Frases de segurança",
        firstCareDoctorInfo = "1º socorro e info médica",
        applicationTitle = "Aplicação",
        cultures = "Cultura(s)",
        targetRegistration = "Alvo(s) de registro",
        applicationRates = "Taxa(s) de aplicação",
        applicationPeriod = "Período de aplicação",
        moreDetailedModeOfAction = "Modo de ação detalhado",
        productStrengths = "Pontos fortes do produto",
        invoiceStatusDue = "Não pago",
        invoiceStatusOverdue = "Em atraso",
        invoiceStatusClosed = "Fechada"
    )
}

